<main>
  <div class="content"><ng-content></ng-content></div>
  <aside>
    @if (sidebar?.entity) {
      <sidebar [feedbackNid]="feedbackNid" [data]="sidebar.entity"></sidebar>
    }
    <ng-content select="[sidebar]"></ng-content>
  </aside>
</main>
